import { render, staticRenderFns } from "./ModalOperacaoIbp.vue?vue&type=template&id=72aa8eda&scoped=true"
import script from "./ModalOperacaoIbp.vue?vue&type=script&lang=js"
export * from "./ModalOperacaoIbp.vue?vue&type=script&lang=js"
import style0 from "./ModalOperacaoIbp.vue?vue&type=style&index=0&id=72aa8eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aa8eda",
  null
  
)

export default component.exports